
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import apiClient from "../../services/apiClient";
import { apiUrl } from "../../services/ApplicantAPIService";
import { submitFlashTestExam, submitFlashTestAnswer, saveStudentStartTime, startFlashTest, getFlashTestResult, checkFlashTestStatus, getFlashTestShowAnswers } from "../../services/flashTestService";
import { useUserContext } from "../common/UserProvider";
import "./css/ApplicantTakeTest.css";
import TestFooter from "../common/TestFooter";
import sirenImg from "../../images/dashboard/siren.png";
const COLOR_SCHEMES = {
  1: "testmoz",
  2: "corporate-blue",
  3: "crimson-gray",
  4: "genghis",
  5: "bitlabs",
  6: "rkce",
  7: "tekworks"
};

const themeStyles = {
  bitlabs: {
    id: "bitlabs",
    primary: "#F68318",
    secondary: "#e66a0e",
    border: "2px solid #FF9D01",
    subColor: "#EF8C2F",
    progressBg: "linear-gradient(90deg, #fbbb5c 0%, #e66a0e 100%)",
    expBg: "#ffedd5",
    expText: "#c2410c",
    highlightBg: "#ea580c"
  },
  testmoz: {
    id: "testmoz",
    primary: "#64748b",
    secondary: "#475569",
    border: "2px solid #cbd5e1",
    subColor: "#475569",
    progressBg: "#64748b",
    expBg: "#fef08a",
    expText: "#854d0e",
    highlightBg: "#cbd5e1"
  },
  corporate_blues: {
    id: "corporate_blues",
    primary: "#2563eb",
    secondary: "#1d4ed8",
    border: "2px solid #2563eb",
    subColor: "#2563eb",
    progressBg: "#2563eb",
    expBg: "#dbeafe",
    expText: "#1e40af",
    highlightBg: "#cbd5e1"
  },
  crimson_gray: {
    id: "crimson_gray",
    primary: "#800000",
    secondary: "#991b1b",
    border: "2px solid #800000",
    subColor: "#800000",
    progressBg: "#800000",
    expBg: "#e2e8f0",
    expText: "#334155",
    highlightBg: "#cbd5e1"
  },
  genghis: {
    id: "genghis",
    primary: "#fbbf24",
    secondary: "#facc15",
    border: "2px solid #1e1e1e",
    subColor: "#fbbf24",
    progressBg: "#fbbf24",
    expBg: "#fef08a",
    expText: "#713f12",
    highlightBg: "#facc15"
  },
  rkce: {
    id: "rkce",
    primary: "#475569",
    secondary: "#1e293b",
    border: "2px solid #cbd5e1",
    subColor: "#1e293b",
    progressBg: "#475569",
    expBg: "#fef08a",
    expText: "#854d0e",
    highlightBg: "#cbd5e1"
  },
  tekworks: {
    id: "tekworks",
    primary: "#3b82f6",
    secondary: "#4f46e5",
    border: "2px solid #cbd5e1",
    subColor: "#3b82f6",
    progressBg: "#3b82f6",
    expBg: "#e0e7ff",
    expText: "#3730a3",
    highlightBg: "#cbd5e1"
  }
};

const ApplicantFlashTest = () => {
  const { testId } = useParams();
  const navigate = useNavigate();
  const { user } = useUserContext();

  const isSubmittingRef = useRef(false);
  const handleSubmitTestRef = useRef(null);
  const isViolationSubmittedRef = useRef(false);

  const [testData, setTestData] = useState(null);
  const [error, setError] = useState(null);

  const backendSchemeId = testData?.settings?.colorScheme || 5;
  const rawTheme = COLOR_SCHEMES[backendSchemeId] || "bitlabs";
  const activeThemeId = rawTheme === "corporate-blue" ? "corporate_blues" : rawTheme === "crimson-gray" ? "crimson_gray" : rawTheme;
  const theme = themeStyles[activeThemeId] || themeStyles.bitlabs;

  const [currentPage, setCurrentPage] = useState("instructions");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [activeReviewQuestionIndex, setActiveReviewQuestionIndex] = useState(0);
  const [reviewPageIndex, setReviewPageIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [visitedQuestions, setVisitedQuestions] = useState({ 0: true });
  const [remainingTime, setRemainingTime] = useState(30 * 60); // 30 minutes
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
  const [showFullscreenExitModal, setShowFullscreenExitModal] = useState(false);
  const [isSubmittingTest, setIsSubmittingTest] = useState(false);
  const [isViolationSubmitted, setIsViolationSubmitted] = useState(false);
  const [score, setScore] = useState(null);
  const [showAttemptedPopup, setShowAttemptedPopup] = useState(false);
  const [showTestClosedPopup, setShowTestClosedPopup] = useState(false);
  const [checkingAttempt, setCheckingAttempt] = useState(false);

  // Passcode entry states
  const [typedPasscode, setTypedPasscode] = useState("");
  const [passcodeError, setPasscodeError] = useState("");
  const [passcodeVerified, setPasscodeVerified] = useState(false);

  // Candidate details states
  const [candidateName, setCandidateName] = useState("");
  const [candidateCollege, setCandidateCollege] = useState("");
  const [candidateEmail, setCandidateEmail] = useState(user?.email || "");

  // useEffect(() => {
  //   if (user?.email) {
  //     setCandidateEmail(user.email);
  //   }
  // }, [user?.email]);
  const [candidateBranch, setCandidateBranch] = useState("");
  const [candidateRegno, setCandidateRegno] = useState("");
  const [candidatePhone, setCandidatePhone] = useState("");
  const [candidateInfoError, setCandidateInfoError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const [examDbId, setExamDbId] = useState(null);

  // DB student ID returned after registration on Continue
  const [registeredStudentId, setRegisteredStudentId] = useState(null);
  const [startingTest, setStartingTest] = useState(false);

  // Test timing
  const [startTime, setStartTime] = useState(null);
  const checkIfAlreadyAttempted = async (emailToCheck) => {
    if (!emailToCheck) return false;
    const trimmedEmail = emailToCheck.trim().toLowerCase();

    // 1. Check local storage attempts first
    const attemptId = testId || "latest";
    const attemptsKey = `flashTestAttempts_${attemptId}`;
    const attemptsData = localStorage.getItem(attemptsKey);
    if (attemptsData) {
      try {
        const attempts = JSON.parse(attemptsData);
        if (Array.isArray(attempts)) {
          const matchingAttempts = attempts.filter(
            (att) => att.email && att.email.trim().toLowerCase() === trimmedEmail
          );
          if (matchingAttempts.length > 0) {
            return true;
          }
        }
      } catch (e) {
        console.error("[ApplicantFlashTest] Error parsing attempts list", e);
      }
    }

    // 2. Check backend for student records with the same email
    const checkDbId = examDbId || testId;
    if (checkDbId) {
      try {
        const response = await axios.get(
          `${apiUrl}/test/students/${checkDbId}`,
          { headers: { "Content-Type": "application/json" }, timeout: 5000 }
        );
        if (response && response.data && Array.isArray(response.data)) {
          const found = response.data.find(
            (student) => student.email && student.email.trim().toLowerCase() === trimmedEmail
          );
          if (found) {
            return true;
          }
        }
      } catch (err) {
        console.error("[ApplicantFlashTest] Error checking backend student attempts:", err);
      }
    }
    return false;
  };

  useEffect(() => {
    if (user?.email) {
      setCandidateEmail(user.email);
    }
  }, [user?.email]);

  useEffect(() => {
    // Clear temporary candidate details on fresh mount so that reloading the tab or
    // re-entering the link starts with a clean, empty Candidate Details form.
    localStorage.removeItem("flashCandidateDetails");
    localStorage.removeItem("flashTestApplicantId");
    localStorage.removeItem("flashRegisteredStudentId");
  }, []);

  useEffect(() => {
    const runPrefillCheck = async () => {
      if (examDbId && user?.email) {
        const alreadyAttempted = await checkIfAlreadyAttempted(user.email);
        if (alreadyAttempted) {
          setShowAttemptedPopup(true);
        }
      }
    };
    runPrefillCheck();
  }, [examDbId, user?.email]);

  // Prevent browser refresh/close when taking the test
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (currentPage === "test") {
        e.preventDefault();
        e.returnValue = "Are you sure you want to leave the test? Your current progress will be lost.";
        return e.returnValue;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [currentPage]);

  // Detect tab switching (visibility change) during the test and auto-submit
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (currentPage === "test" && !isSubmittingRef.current) {
        if (document.visibilityState === "hidden" || document.hidden) {
          isViolationSubmittedRef.current = true;
          setIsViolationSubmitted(true);
          setShowFullscreenExitModal(false);

          // Send tab switch notification to backend
          const tabSwitchPayload = {
            examId: testId,
            email: candidateEmail ? candidateEmail.trim() : "",
            tabswitch: 1
          };
          saveStudentStartTime(tabSwitchPayload)
            .then(() => {
              console.log("[ApplicantFlashTest] Sent tab-switch payload to backend:", tabSwitchPayload);
            })
            .catch((err) => {
              console.error("[ApplicantFlashTest] Failed to send tab-switch payload:", err.message || err);
            })
            .finally(() => {
              if (handleSubmitTestRef.current) {
                handleSubmitTestRef.current();
              }
            });
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentPage, testId, candidateEmail]);

  // Block refresh keys (F5, Ctrl+R, Cmd+R)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentPage === "test") {
        if (
          e.key === "F5" ||
          ((e.ctrlKey || e.metaKey) && e.key === "r") ||
          ((e.ctrlKey || e.metaKey) && e.key === "R")
        ) {
          e.preventDefault();
          alert("Page refresh is disabled during the test.");
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentPage]);

  // Detect exiting fullscreen and warn/re-enter
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (currentPage === "test" && !isSubmittingRef.current) {
        const isFullscreen = document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement;
        if (!isFullscreen) {
          if (document.visibilityState !== "hidden" && !document.hidden) {
            setShowFullscreenExitModal(true);
          }
        }
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullscreenChange);

      // Exit fullscreen when exiting the test page
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => console.error("Error exiting fullscreen:", err));
      }
    };
  }, [currentPage]);




  // Load test data from Backend / localStorage
  useEffect(() => {
    const fetchTestData = async () => {
      let dataLoaded = false;
      let examDetails = null;
      let parsed = null;

      // 1. Fetch from backend using plain axios (no JWT needed — public endpoint)
      if (testId) {
        try {
          // Fetch dynamic Exam ID (bigint)
          try {
            const examResponse = await axios.get(
              `${apiUrl}/test/exam/${testId}`,
              { headers: { "Content-Type": "application/json" }, timeout: 10000 }
            );
            if (examResponse && examResponse.data) {
              examDetails = examResponse.data;
              setExamDbId(examResponse.data.id);
              console.log("[ApplicantFlashTest] Dynamic exam ID fetched:", examResponse.data.id);
            }
          } catch (examErr) {
            console.error("[ApplicantFlashTest] Could not fetch exam details:", examErr.message || examErr);
          }

          const response = await startFlashTest(testId);

          if (response && response.data) {
            const resData = response.data;

            // The API returns a plain array of questions OR an object with a questions field
            const fetchedQuestions = Array.isArray(resData)
              ? resData
              : Array.isArray(resData.questions)
                ? resData.questions
                : [];

            if (fetchedQuestions.length === 0) {
              throw new Error("Empty questions array returned from API");
            }

            // Debug: log the first raw question to inspect the ID field name from API
            console.log("[ApplicantFlashTest] Raw question sample from API:", fetchedQuestions[0]);

            // Map directly — keep raw backend field names intact
            // We preserve ALL original fields from the backend response to ensure
            // questionId is never lost regardless of the field name used by the backend.
            const mappedQuestions = fetchedQuestions.map(q => {
              // Try every possible ID field the backend might use
              const resolvedId = q.id ?? q.questionId ?? q.question_id ?? q.qid ?? q.examQuestionId ?? null;
              console.log(`[ApplicantFlashTest] Question resolved id: ${resolvedId} from fields:`, { id: q.id, questionId: q.questionId, question_id: q.question_id });
              return {
                // Preserve the original question object fields
                ...q,
                // Explicitly set id to the resolved value
                id: resolvedId,
                question: q.question || "",
                code: q.code || "",
                // options can be { A: "...", B: "...", ... } OR { a: "...", b: "...", ... }
                options: q.options || {},
                correctOption: (q.correctOption || "A").toUpperCase(),
                answerText: q.answerText || ""
              };
            });

            // Build exam metadata — when API returns a plain array,
            // resData.* is undefined so we fall back to sensible defaults.
            const examMeta = examDetails || (Array.isArray(resData) ? {} : resData);

            // Attempt to load settings from localStorage for the active testId
            let localSettings = null;
            try {
              const localTestData = localStorage.getItem(`flashTest_${testId}`);
              if (localTestData) {
                const parsedLocal = JSON.parse(localTestData);
                if (parsedLocal && parsedLocal.settings) {
                  localSettings = parsedLocal.settings;
                }
              }
            } catch (e) {
              console.warn("Failed to read local test settings:", e);
            }

            // Fallback to global flashTestSettings if not found
            if (!localSettings) {
              try {
                const globalSettings = localStorage.getItem("flashTestSettings");
                if (globalSettings) {
                  localSettings = JSON.parse(globalSettings);
                }
              } catch (e) {
                console.warn("Failed to read global flashTestSettings:", e);
              }
            }

            let backendSchemeId = parseInt(examMeta.colorScheme ?? examMeta.color_scheme);
            if (isNaN(backendSchemeId) || backendSchemeId < 1 || backendSchemeId > 7) {
              backendSchemeId = 5;
            }

            let backendShowAnswers = true;
            try {
              const showAnswersRes = await getFlashTestShowAnswers(examMeta.id || examMeta.examId || testId);
              if (showAnswersRes && showAnswersRes.data && showAnswersRes.data.showAnswers !== undefined) {
                backendShowAnswers = showAnswersRes.data.showAnswers;
              }
            } catch (err) {
              console.warn("Could not fetch exam-show-answers, falling back to local settings", err);
              backendShowAnswers = localSettings?.showAnswers ?? true;
            }

            const mergedSettings = {
              passcode: localSettings?.passcode || examMeta.passcode || "",
              timeLimit: localSettings?.timeLimit || (examMeta.timeLimit ?? 30),
              passingScore: localSettings?.passingScore || (examMeta.passingScore ?? 70),
              maxAttempts: localSettings?.maxAttempts ?? 1,
              showScore: localSettings?.showScore ?? true,
              showAnswers: backendShowAnswers,
              shuffleQuestions: localSettings?.shuffleQuestions ?? false,
              shuffleChoices: localSettings?.shuffleChoices ?? false,
              colorScheme: backendSchemeId
            };

            parsed = {
              id: examMeta.id || examMeta.examId || testId,
              examName: examMeta.examName || examMeta.name || "Flash Test",
              subject: examMeta.subject || "",
              category: examMeta.category || "Technical",
              difficulty: examMeta.difficulty || "",
              questions: mappedQuestions,
              duration: examMeta.duration || 0,
              settings: mergedSettings,
              isActive: examMeta.isActive !== undefined ? examMeta.isActive : true
            };
            dataLoaded = true;
          }
        } catch (err) {
          console.error("[ApplicantFlashTest] Could not fetch questions from API:", err.message || err);
          setError("Unable to load test questions. Please use a valid test link or contact the recruiter.");
          return;
        }
      } else {
        setError("Invalid test link. No test ID found in the URL.");
        return;
      }

      if (dataLoaded && parsed) {
        // Set remaining time from settings if available
        if (parsed.duration && parsed.duration > 0) {
          setRemainingTime(parsed.duration * 60);
        } else if (parsed.settings && parsed.settings.timeLimit && parsed.settings.timeLimit > 0) {
          setRemainingTime(parsed.settings.timeLimit * 60);
        } else {
          setRemainingTime(30 * 60); // Default to 30 mins
        }

        // Shuffle helper function
        const shuffleArray = (array) => {
          const arr = [...array];
          for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
          }
          return arr;
        };

        // Handle question/option shuffling based on settings
        let parsedQuestions = parsed.questions || [];
        if (parsed.settings?.shuffleQuestions && parsedQuestions.length > 0) {
          parsedQuestions = shuffleArray(parsedQuestions);
        }

        if (parsed.settings?.shuffleChoices && parsedQuestions.length > 0) {
          parsedQuestions = parsedQuestions.map(q => ({
            ...q,
            options: shuffleArray(q.options)
          }));
        }

        setTestData({
          ...parsed,
          questions: parsedQuestions
        });

        if (parsed.isActive === false) {
          setShowTestClosedPopup(true);
        }

        // Check if passcode verification is required
        if (parsed.settings && parsed.settings.passcode && parsed.settings.passcode.trim() !== "") {
          setPasscodeVerified(false);
          setCurrentPage("passcode");
        } else {
          setPasscodeVerified(true);
          setCurrentPage("candidate-info");
        }
      } else {
        setError("No questions were returned. Please contact the recruiter.");
      }
    };

    fetchTestData();
  }, [testId]);

  // Countdown timer logic
  useEffect(() => {
    let interval;
    if (currentPage === "test" && remainingTime > 0) {
      interval = setInterval(() => {
        setRemainingTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(interval);
            handleSubmitTest();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [currentPage, remainingTime]);

  useEffect(() => {
    if (currentPage === "test") {
      setVisitedQuestions((prev) => ({ ...prev, [currentQuestionIndex]: true }));
    }
  }, [currentQuestionIndex, currentPage]);

  if (error) {
    return (
      <div style={{ padding: "40px 20px", textAlign: "center", background: "#fff", borderRadius: "12px", border: "1px solid #fca5a5", margin: "110px auto 20px auto", maxWidth: "600px" }}>
        <div style={{ fontSize: "48px", marginBottom: "15px" }}>⚠️</div>
        <h3 style={{ color: "#ef4444", marginBottom: "10px", fontSize: "20px", fontWeight: "700" }}>Error Loading Assessment</h3>
        <p style={{ color: "#6b7280", maxWidth: "500px", margin: "0 auto 20px" }}>{error}</p>
        <button onClick={() => navigate("/applicanthome")} className="second-btn" style={{ padding: "8px 24px" }}>
          Go to Dashboard
        </button>
      </div>
    );
  }

  if (!testData) {
    return (
      <div style={{ padding: "60px", textAlign: "center" }}>
        <div className="spinner-container" style={{ borderTopColor: "#e66a0e", width: "30px", height: "30px" }} />
        <p style={{ marginTop: "15px", color: "#6b7280" }}>Loading assessment details...</p>
      </div>
    );
  }

  const { subject, category, difficulty, questions } = testData;

  const handleVerifyPasscode = () => {
    if (typedPasscode.trim() === (testData.settings?.passcode || "").trim()) {
      setPasscodeVerified(true);
      setCurrentPage("candidate-info");
    } else {
      setPasscodeError("Incorrect passcode. Please try again.");
    }
  };

  const handleSaveCandidateInfo = async () => {
    try {
      const statusRes = await checkFlashTestStatus(testId);
      if (statusRes.data && statusRes.data.isActive === false) {
        setShowTestClosedPopup(true);
        setCheckingAttempt(false);
        return;
      }
    } catch (e) {
      console.error("[ApplicantFlashTest] Could not verify if test is active:", e);
      // Proceed if API fails so we don't completely block candidates on a random network glitch,
      // or optionally block them. Assuming we proceed.
    }

    const trimmedName = candidateName.trim();
    const trimmedCollege = candidateCollege.trim();
    const trimmedEmail = candidateEmail.trim();
    const trimmedBranch = candidateBranch.trim();
    const trimmedRegno = candidateRegno.trim();
    const trimmedPhone = candidatePhone.trim();

    const errors = {};
    if (!trimmedName) {
      errors.name = "Full name is required.";
    } else if (trimmedName.length < 3 || trimmedName.length > 50) {
      errors.name = "Full name must be between 3 and 50 characters.";
    } else if (/\d/.test(trimmedName)) {
      errors.name = "Full name should not contain numbers.";
    } else if (!/^[a-zA-Z\s]+$/.test(trimmedName)) {
      errors.name = "Full name should contain letters only.";
    }

    if (!trimmedCollege) {
      errors.college = "College name is required.";
    } else if (trimmedCollege.length < 3 || trimmedCollege.length > 100) {
      errors.college = "College name must be between 3 and 100 characters.";
    } else if (!/^[a-zA-Z\s]+$/.test(trimmedCollege)) {
      errors.college = "College name should contain letters only.";
    }

    if (!trimmedEmail) {
      errors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      errors.email = "Please enter a valid email address.";
    }

    if (!trimmedBranch) {
      errors.branch = "Branch is required.";
    } else if (trimmedBranch.length < 3 || trimmedBranch.length > 50) {
      errors.branch = "Branch name must be between 3 and 50 characters.";
    } else if (/\d/.test(trimmedBranch)) {
      errors.branch = "Branch should not contain numbers.";
    }

    if (!trimmedRegno) {
      errors.regno = "Register number is required.";
    } else if (trimmedRegno.length < 3 || trimmedRegno.length > 50) {
      errors.regno = "Register number must be between 3 and 50 characters.";
    }

    if (!trimmedPhone) {
      errors.phone = "Phone number is required.";
    } else if (!/^[6-9]\d{9}$/.test(trimmedPhone)) {
      errors.phone = "Phone number must be exactly 10 digits and start with 6, 7, 8, or 9.";
    }

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setCandidateInfoError("Please fix the errors above.");
      return;
    }
    setFieldErrors({});
    setCandidateInfoError("");
    setCheckingAttempt(true);
    const alreadyAttempted = await checkIfAlreadyAttempted(trimmedEmail);
    if (alreadyAttempted) {
      setCheckingAttempt(false);
      setShowAttemptedPopup(true);
      return;
    }
    setCheckingAttempt(false);

    // Generate a stable applicant ID for the duration of this exam session
    const applicantId = user?.id ? user.id.toString() : (Math.floor(Math.random() * 900000) + 100000).toString();
    localStorage.setItem("flashTestApplicantId", applicantId);

    // Always keep a local copy as a fallback
    const candidatePayload = {
      name: trimmedName,
      college: trimmedCollege,
      email: trimmedEmail,
      branch: trimmedBranch,
      regno: trimmedRegno,
      phoneno: trimmedPhone
    };
    localStorage.setItem("flashCandidateDetails", JSON.stringify(candidatePayload));

    // Check for max attempts limit matching this candidate name and college
    const attemptId = testId || "latest";
    const attemptsKey = `flashTestAttempts_${attemptId}`;
    const attemptsData = localStorage.getItem(attemptsKey);
    if (attemptsData) {
      try {
        const attempts = JSON.parse(attemptsData);
        if (Array.isArray(attempts)) {
          const matchingAttempts = attempts.filter(
            (att) =>
              att.name.trim().toLowerCase() === trimmedName.toLowerCase() &&
              att.college.trim().toLowerCase() === trimmedCollege.toLowerCase() &&
              att.completed
          );
          const maxAttempts = testData.settings?.maxAttempts ?? 1;
          if (maxAttempts > 0 && matchingAttempts.length >= maxAttempts) {
            setCandidateInfoError(
              `You have already completed this test. Maximum attempts allowed: ${maxAttempts}.`
            );
            return;
          }
        }
      } catch (e) {
        console.error("Error parsing attempts list", e);
      }
    }

    setCurrentPage("instructions");
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handleBackQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleQuestionClick = (index) => {
    setVisitedQuestions((prev) => ({ ...prev, [index]: true }));
    setCurrentQuestionIndex(index);
  };

  const handleOptionChange = (event) => {
    const selectedOption = event.target.value;
    setSelectedOptions({
      ...selectedOptions,
      [currentQuestionIndex]: selectedOption,
    });
  };

  const handleExit = () => {
    setShowExitPopup(true);
  };

  const handleStartTest = async () => {
    if (startingTest) return;
    setStartingTest(true);

    let studentId = null;
    try {
      const studentPayload = {
        name: candidateName.trim(),
        college: candidateCollege.trim(),
        email: candidateEmail.trim(),
        branch: candidateBranch.trim(),
        regno: candidateRegno.trim(),
        phoneno: candidatePhone.trim(),
        exam: {
          id: examDbId
        }
      };

      const regResponse = await axios.post(
        `${apiUrl}/test/student/save/${testId}`,
        studentPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (regResponse?.data && typeof regResponse.data === "object") {
        studentId = regResponse.data.id;
      }

      if (studentId) {
        setRegisteredStudentId(studentId);
        localStorage.setItem("flashRegisteredStudentId", String(studentId));
        console.log(`[ApplicantFlashTest] Student registered in DB with id=${studentId}`);
      } else {
        console.log("[ApplicantFlashTest] Registration response:", regResponse?.data);
      }
    } catch (regErr) {
      console.error("[ApplicantFlashTest] Could not register student in DB:", regErr);
      const errorMsg = regErr.response?.data || "";
      const errorStr = typeof errorMsg === "string" ? errorMsg : JSON.stringify(errorMsg);
      const lowerErrorStr = errorStr.toLowerCase();

      if (
        lowerErrorStr.includes("uk_student_email_exam") ||
        lowerErrorStr.includes("constraintviolationexception") ||
        lowerErrorStr.includes("duplicate") ||
        lowerErrorStr.includes("already attempted") ||
        regErr.response?.status === 409
      ) {
        setShowAttemptedPopup(true);
        setStartingTest(false);
        return;
      }
      // Non-blocking for other errors — proceed
    }

    setStartTime(Date.now());
    setCurrentPage("test");

    // Request fullscreen mode
    try {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen().catch(err => console.error("Error requesting fullscreen:", err));
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    } catch (fsErr) {
      console.error("[ApplicantFlashTest] Fullscreen request failed:", fsErr);
    }

    try {
      const startPayload = {
        examId: testId,
        email: candidateEmail.trim()
      };
      await saveStudentStartTime(startPayload);
      console.log("[ApplicantFlashTest] Sent start-time payload:", startPayload);
    } catch (err) {
      console.error("[ApplicantFlashTest] Failed to send start-time to backend:", err.message || err);
    } finally {
      setStartingTest(false);
    }
  };

  const handleSubmitTest = async () => {
    if (isSubmittingRef.current) {
      console.log("[ApplicantFlashTest] Submission already in progress. Ignoring duplicate call.");
      return;
    }
    isSubmittingRef.current = true;
    setIsSubmittingTest(true);
    setShowFullscreenExitModal(false);
    const finishedOn = Date.now();
    let correctCount = 0;
    const questionResults = questions.map((q, index) => {
      const isCorrect = selectedOptions[index] === q.correctOption;
      if (isCorrect) correctCount++;
      return isCorrect;
    });

    const calculatedScore = Math.round((correctCount / questions.length) * 100);
    setScore(calculatedScore);

    const totalQuestions = questions.length;
    const attemptedCount = Object.keys(selectedOptions).length;
    const wrongCount = attemptedCount - correctCount;
    const durationMs = startTime ? finishedOn - startTime : null;

    // Real applicantId (from applicant table) — required by /test/submit backend validation
    const realApplicantId = parseInt(localStorage.getItem("flashTestApplicantId") || "18236");
    // Student table ID — this is the ID the recruiter sees in /test/students/{examId}
    const studentTableId = parseInt(localStorage.getItem("flashRegisteredStudentId") || "0");

    // 1. Build answers payload
    const answersPayload = {};
    questions.forEach((q, index) => {
      const selectedOptionKey = selectedOptions[index];
      const questionId = q.id ?? q.questionId ?? q.question_id ?? q.qid ?? q.examQuestionId ?? null;
      if (questionId) {
        answersPayload[questionId] = selectedOptionKey || "";
      }
    });

    const payload = {
      applicantId: realApplicantId,
      answers: answersPayload
    };
    if (isViolationSubmittedRef.current) {
      payload.tabswitch = 1;
    }

    let finalScore = calculatedScore;

    // 2. Submit with real applicantId (backend validates this against applicant table)
    try {
      const submitResponse = await submitFlashTestExam(testId, payload);
      if (submitResponse && submitResponse.data && submitResponse.data.percentage !== undefined) {
        finalScore = Math.round(submitResponse.data.percentage);
        setScore(finalScore);
      }
    } catch (submitErr) {
      console.error("Failed to submit answers:", submitErr);
    }

    // 3. Also store answers under the student table ID via /test/submission
    //    so the recruiter can call /test/testmoz-result/{examId}/{studentTableId}
    if (studentTableId > 0) {
      try {
        const submissionPayload = Object.entries(answersPayload).map(([questionId, userOption]) => ({
          questionId: parseInt(questionId),
          userOption,
          applicantId: studentTableId
        }));
        if (submissionPayload.length > 0) {
          await submitFlashTestAnswer(submissionPayload);
        }
      } catch (subErr) {
        // Non-blocking — recruiter review may not show answers but test still completes
        console.error("Failed to store answers for recruiter review:", subErr);
      }
    }

    // Save completion result to localStorage
    const attemptId = testId || "latest";
    const attemptsKey = `flashTestAttempts_${attemptId}`;
    const existingAttemptsJson = localStorage.getItem(attemptsKey);
    const existingAttempts = existingAttemptsJson ? JSON.parse(existingAttemptsJson) : [];

    // Retrieve stored candidate details for the attempt record
    let storedCandidate = {};
    try {
      storedCandidate = JSON.parse(localStorage.getItem("flashCandidateDetails") || "{}");
    } catch (e) { }

    const newAttempt = {
      name: storedCandidate.name || candidateName.trim() || "Anonymous Candidate",
      college: storedCandidate.college || candidateCollege.trim() || "N/A",
      email: storedCandidate.email || "",
      branch: storedCandidate.branch || "",
      regno: storedCandidate.regno || "",
      phoneno: storedCandidate.phoneno || "",
      score: finalScore,
      attemptedCount: attemptedCount,
      correctCount: correctCount,
      wrongCount: wrongCount,
      totalQuestions: totalQuestions,
      questionResults: questionResults,
      selectedOptions: selectedOptions,
      startedOn: startTime,
      finishedOn: finishedOn,
      durationMs: durationMs,
      completed: true,
      timestamp: Date.now(),
      applicantId: realApplicantId
    };

    existingAttempts.push(newAttempt);
    localStorage.setItem(attemptsKey, JSON.stringify(existingAttempts));

    // Also update legacy single attempt key for backwards compatibility
    localStorage.setItem(`flashTestAttempt_${attemptId}`, JSON.stringify(newAttempt));

    // Clear temporary candidate details so a new person can take the test afresh
    localStorage.removeItem("flashCandidateDetails");
    localStorage.removeItem("flashTestApplicantId");
    localStorage.removeItem("flashRegisteredStudentId");

    // Fetch actual correct answers from backend testmoz-result before showing scorecard
    if (studentTableId > 0) {
      try {
        const resultRes = await getFlashTestResult(testId, studentTableId);
        
        let latestShowAnswers = testData?.settings?.showAnswers ?? true;
        try {
          const showAnswersRes = await getFlashTestShowAnswers(testId);
          if (showAnswersRes?.data?.showAnswers !== undefined) {
            latestShowAnswers = showAnswersRes.data.showAnswers;
          }
        } catch (err) {
          console.warn("Could not refresh exam-show-answers status at end of test", err);
        }

        if (resultRes?.data && Array.isArray(resultRes.data.questionDetails)) {
          const details = resultRes.data.questionDetails;
          const updatedQuestions = questions.map(q => {
            const detail = details.find(d => String(d.questionId) === String(q.id));
            if (detail) {
              return {
                ...q,
                correctOption: (detail.correctOption || "A").toUpperCase(),
                answerText: detail.correctAnswerText || ""
              };
            }
            return q;
          });
          setTestData(prev => ({
            ...prev,
            questions: updatedQuestions,
            settings: {
              ...(prev?.settings || {}),
              showAnswers: latestShowAnswers
            }
          }));
        } else {
          setTestData(prev => ({
            ...prev,
            settings: {
              ...(prev?.settings || {}),
              showAnswers: latestShowAnswers
            }
          }));
        }
      } catch (err) {
        console.error("[ApplicantFlashTest] Failed to fetch correct answers review:", err);
      }
    }

    setIsSubmittingTest(false);
    setCurrentPage("scorecard");
  };

  handleSubmitTestRef.current = handleSubmitTest;

  const handleReturnToFullscreen = () => {
    const element = document.documentElement;
    const requestFs = element.requestFullscreen ||
      element.webkitRequestFullscreen ||
      element.mozRequestFullScreen ||
      element.msRequestFullscreen;

    if (requestFs) {
      requestFs.call(element)
        .then(() => {
          setShowFullscreenExitModal(false);
        })
        .catch((err) => {
          console.error("Failed to re-enter fullscreen:", err);
          setShowFullscreenExitModal(false);
        });
    } else {
      setShowFullscreenExitModal(false);
    }
  };

  const handleConfirmSubmitFromModal = () => {
    setShowFullscreenExitModal(false);
    if (handleSubmitTestRef.current) {
      handleSubmitTestRef.current();
    }
  };

  // Helper to format code snippets
  const formatQuestionText = (text) => {
    if (!text) return "";
    let formatted = text;

    const codeBlockRegex = /```(?:[a-zA-Z]+)?\n([\s\S]*?)\n```/g;
    formatted = formatted.replace(codeBlockRegex, (match, codeSnippet) => {
      return `<pre class="code-snippet-box" style="background: #1e1e1e; color: #d4d4d4; padding: 12px; border-radius: 6px; font-family: monospace; text-align: left; overflow-x: auto; margin: 15px 0; border-left: 4px solid #F68318;"><code>${codeSnippet.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</code></pre>`;
    });

    formatted = formatted.replace(/`([^`]+)`/g, '<code style="background: #f1f5f9; padding: 2px 6px; border-radius: 4px; font-family: monospace; color: #e11d48;">$1</code>');

    const parts = formatted.split(/(<pre[\s\S]*?<\/pre>)/g);
    for (let i = 0; i < parts.length; i++) {
      if (!parts[i].startsWith("<pre")) {
        parts[i] = parts[i].replace(/\n/g, "<br/>&nbsp;&nbsp;&nbsp;&nbsp;").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
      }
    }
    return parts.join("");
  };

  const containerStyle = {
    "--theme-primary": theme.primary,
    "--theme-secondary": theme.secondary,
    "--theme-border": theme.border,
    "--theme-sub-color": theme.subColor,
    "--theme-progress-bg": theme.progressBg,
    "--theme-exp-bg": theme.expBg,
    "--theme-exp-text": theme.expText,
    "--theme-highlight-bg": theme.highlightBg,
    "--theme-second-hover": theme.primary === '#ffffff' ? '#f1f5f9' : 'rgba(0,0,0,0.02)',
    "--theme-current-bg": theme.primary === '#ffffff' ? '#1e293b' : theme.primary
  };

  return (
    <>
      <div className="test-container" style={containerStyle}>
        {showTestClosedPopup && (
          <div className="exit-popup">
            <div style={{
              background: "white",
              padding: "35px 30px",
              borderRadius: "16px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              maxWidth: "420px",
              width: "90%",
              textAlign: "center",
              fontFamily: "Plus Jakarta Sans"
            }}>
              <div style={{ fontSize: "50px", marginBottom: "15px" }}>🔒</div>
              <h3 style={{ marginBottom: "12px", fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>
                Test is Closed
              </h3>
              <p style={{ color: "#4b5563", marginBottom: "25px", fontSize: "14px", lineHeight: "1.6" }}>
                This test is currently closed and cannot be accessed. If you believe this is a mistake, please contact your recruiter.
              </p>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={() => {
                    setShowTestClosedPopup(false);
                    navigate("/applicanthome");
                  }}
                  className="navigation-btn"
                  style={{
                    background: "#e66a0e",
                    color: "white",
                    border: "none",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "14px"
                  }}
                >
                  Return to Dashboard
                </button>
              </div>
            </div>
          </div>
        )}

        {showAttemptedPopup && (
          <div className="exit-popup">
            <div style={{
              background: "white",
              padding: "35px 30px",
              borderRadius: "16px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              maxWidth: "420px",
              width: "90%",
              textAlign: "center",
              fontFamily: "Plus Jakarta Sans"
            }}>
              <div style={{ fontSize: "50px", marginBottom: "15px" }}>🚫</div>
              <h3 style={{ marginBottom: "12px", fontSize: "20px", fontWeight: "700", color: "#ef4444" }}>
                Already Attempted
              </h3>
              <p style={{ color: "#4b5563", marginBottom: "25px", fontSize: "14px", lineHeight: "1.6" }}>
                A candidate with the email <strong>{candidateEmail}</strong> has already attempted or registered for this assessment.
                Multiple attempts are not permitted.
              </p>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={() => {
                    setShowAttemptedPopup(false);
                    navigate("/applicanthome");
                  }}
                  className="navigation-btn"
                  style={{
                    background: "#e66a0e",
                    color: "white",
                    border: "none",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "14px"
                  }}
                >
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        )}


        {showExitPopup && (
          <div className="exit-popup">
            <div style={{
              background: "white",
              padding: "30px",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              maxWidth: "400px",
              textAlign: "center"
            }}>
              <h3 style={{ marginBottom: "15px", fontSize: "18px", fontWeight: "700", fontFamily: "Plus Jakarta Sans" }}>Exit Test?</h3>
              <p style={{ color: "#666", marginBottom: "20px", fontSize: "14px", fontFamily: "Plus Jakarta Sans" }}>
                Are you sure you want to exit? Your current test progress will be lost.
              </p>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <button
                  onClick={() => navigate("/applicanthome")}
                  className="navigation-btn"
                  style={{ background: "#e66a0e", color: "white", border: "none", padding: "8px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" }}
                >
                  Yes, Exit
                </button>
                <button
                  onClick={() => setShowExitPopup(false)}
                  className="second-btn"
                  style={{ padding: "8px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showSubmitConfirm && (
          <div className="exit-popup">
            <div style={{
              background: "white",
              padding: "30px",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center"
            }}>
              <h3 style={{ marginBottom: "15px", fontSize: "18px", fontWeight: "700", fontFamily: "Plus Jakarta Sans" }}>Submit Test?</h3>
              <p style={{ color: "#666", marginBottom: "20px", fontSize: "14px", fontFamily: "Plus Jakarta Sans" }}>
                Are you sure to submit the exam?
              </p>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <button
                  onClick={() => {
                    setShowSubmitConfirm(false);
                    handleSubmitTest();
                  }}
                  className="navigation-btn"
                  style={{ background: "#1aae55", color: "white", border: "none", padding: "8px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" }}
                >
                  Yes
                </button>
                <button
                  onClick={() => setShowSubmitConfirm(false)}
                  className="navigation-btn"
                  style={{ background: "#6c757d", color: "white", border: "none", padding: "8px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ====== Passcode Verification Page ====== */}
        {currentPage === "passcode" && testData?.settings?.passcode && !passcodeVerified && (
          <div className="instructions-page" style={{ maxWidth: "500px", margin: "110px auto 20px auto" }}>
            <h2 className="text-name" style={{ textAlign: "center", fontSize: "22px", fontWeight: "700", marginBottom: "15px" }}>
              Unlock Assessment
            </h2>
            <p style={{ textAlign: "center", color: "#64748b", marginBottom: "25px", fontSize: "14px" }}>
              This Flash Test is passcode protected. Please enter the passcode provided by the recruiter to start the exam.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px", textAlign: "left" }}>
              <label style={{ fontSize: "14px", fontWeight: "600", color: "#475569" }}>Passcode</label>
              <input
                type="password"
                value={typedPasscode}
                onChange={(e) => {
                  setTypedPasscode(e.target.value);
                  setPasscodeError("");
                }}
                placeholder="Enter passcode..."
                style={{
                  padding: "12px 16px",
                  border: passcodeError ? "1px solid #ef4444" : "1px solid #cbd5e1",
                  borderRadius: "8px",
                  fontSize: "14px",
                  width: "100%",
                  outline: "none"
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleVerifyPasscode();
                  }
                }}
              />
              {passcodeError && (
                <span style={{ color: "#ef4444", fontSize: "12px", marginTop: "2px" }}>
                  {passcodeError}
                </span>
              )}
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "10px" }}>
              <button
                onClick={handleVerifyPasscode}
                className="start-btn"
                style={{ flex: 1, padding: "12px" }}
              >
                Verify & Proceed
              </button>
              <button
                onClick={() => navigate("/applicanthome")}
                className="second-btn"
                style={{ padding: "12px 20px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* ====== Candidate Info Page ====== */}
        {currentPage === "candidate-info" && passcodeVerified && (
          <div className="instructions-page" style={{ maxWidth: "520px", margin: "110px auto 20px auto" }}>
            <h2 className="text-name" style={{ textAlign: "center", fontSize: "22px", fontWeight: "700", marginBottom: "8px" }}>
              Candidate Details
            </h2>
            <p style={{ textAlign: "center", color: "#64748b", marginBottom: "22px", fontSize: "14px" }}>
              Please fill in all details before starting the assessment.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "14px", marginBottom: "20px", textAlign: "left" }}>

              {/* Full Name */}
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Full Name <span style={{ color: "#ef4444" }}>*</span></label>
                <input
                  type="text"
                  value={candidateName}
                  onChange={(e) => { setCandidateName(e.target.value); setFieldErrors(p => ({ ...p, name: "" })); }}
                  placeholder="Enter your full name"
                  style={{
                    padding: "11px 14px",
                    border: `1px solid ${fieldErrors.name ? "#ef4444" : "#cbd5e1"}`,
                    borderRadius: "8px", fontSize: "14px", width: "100%", outline: "none", boxSizing: "border-box"
                  }}
                />
                {fieldErrors.name && <span style={{ color: "#ef4444", fontSize: "12px" }}>{fieldErrors.name}</span>}
              </div>

              {/* Register Number */}
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Roll No<span style={{ color: "#ef4444" }}>*</span></label>
                <input
                  type="text"
                  value={candidateRegno}
                  onChange={(e) => { setCandidateRegno(e.target.value); setFieldErrors(p => ({ ...p, regno: "" })); }}
                  placeholder="Enter your register number"
                  style={{
                    padding: "11px 14px",
                    border: `1px solid ${fieldErrors.regno ? "#ef4444" : "#cbd5e1"}`,
                    borderRadius: "8px", fontSize: "14px", width: "100%", outline: "none", boxSizing: "border-box"
                  }}
                />
                {fieldErrors.regno && <span style={{ color: "#ef4444", fontSize: "12px" }}>{fieldErrors.regno}</span>}
              </div>

              {/* Email */}
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Email Id <span style={{ color: "#ef4444" }}>*</span></label>
                <input
                  type="email"
                  value={candidateEmail}
                  onChange={(e) => { setCandidateEmail(e.target.value); setFieldErrors(p => ({ ...p, email: "" })); }}
                  placeholder="Enter your email"
                  disabled={!!user?.email}
                  style={{
                    padding: "11px 14px",
                    border: `1px solid ${fieldErrors.email ? "#ef4444" : "#cbd5e1"}`,
                    borderRadius: "8px", fontSize: "14px", width: "100%", outline: "none", boxSizing: "border-box", backgroundColor: "#F6F6F6",
                    backgroundColor: user?.email ? "#f1f5f9" : "white",
                    color: user?.email ? "#64748b" : "black",
                    cursor: user?.email ? "not-allowed" : "text"
                  }}
                />
                {fieldErrors.email && <span style={{ color: "#ef4444", fontSize: "12px" }}>{fieldErrors.email}</span>}
              </div>

              {/* Phone Number */}
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Phone Number <span style={{ color: "#ef4444" }}>*</span></label>
                <input
                  type="tel"
                  value={candidatePhone}
                  onChange={(e) => { setCandidatePhone(e.target.value.replace(/\D/g, "").slice(0, 10)); setFieldErrors(p => ({ ...p, phone: "" })); }}
                  placeholder="Enter 10-digit phone number"
                  maxLength={10}
                  style={{
                    padding: "11px 14px",
                    border: `1px solid ${fieldErrors.phone ? "#ef4444" : "#cbd5e1"}`,
                    borderRadius: "8px", fontSize: "14px", width: "100%", outline: "none", boxSizing: "border-box", backgroundColor: "#F6F6F6",
                  }}
                />
                {fieldErrors.phone && <span style={{ color: "#ef4444", fontSize: "12px" }}>{fieldErrors.phone}</span>}
              </div>

              {/* College / Institution */}
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>College / Institution <span style={{ color: "#ef4444" }}>*</span></label>
                <input
                  type="text"
                  value={candidateCollege}
                  onChange={(e) => { setCandidateCollege(e.target.value); setFieldErrors(p => ({ ...p, college: "" })); }}
                  placeholder="Enter your college name"
                  style={{
                    padding: "11px 14px",
                    border: `1px solid ${fieldErrors.college ? "#ef4444" : "#cbd5e1"}`,
                    borderRadius: "8px", fontSize: "14px", width: "100%", outline: "none", boxSizing: "border-box"
                  }}
                />
                {fieldErrors.college && <span style={{ color: "#ef4444", fontSize: "12px" }}>{fieldErrors.college}</span>}
              </div>

              {/* Branch */}
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Branch <span style={{ color: "#ef4444" }}>*</span></label>
                <input
                  type="text"
                  value={candidateBranch}
                  onChange={(e) => { setCandidateBranch(e.target.value); setFieldErrors(p => ({ ...p, branch: "" })); }}
                  placeholder="Computer Science, ECE"
                  onKeyDown={(e) => { if (e.key === "Enter") handleSaveCandidateInfo(); }}
                  style={{
                    padding: "11px 14px",
                    border: `1px solid ${fieldErrors.branch ? "#ef4444" : "#cbd5e1"}`,
                    borderRadius: "8px", fontSize: "14px", width: "100%", outline: "none", boxSizing: "border-box"
                  }}
                />
                {fieldErrors.branch && <span style={{ color: "#ef4444", fontSize: "12px" }}>{fieldErrors.branch}</span>}
              </div>

            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "6px" }}>
              <button
                onClick={handleSaveCandidateInfo}
                className="start-btn"
                disabled={checkingAttempt}
                style={{ flex: 1, padding: "12px", opacity: checkingAttempt ? 0.7 : 1, cursor: checkingAttempt ? "not-allowed" : "pointer" }}
              >
                {checkingAttempt ? "Checking..." : "Continue"}
              </button>
              <button
                onClick={() => navigate("/applicanthome")}
                className="second-btn"
                style={{ flex: 1, padding: "12px", textAlign: "center" }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}


        {/* ====== Instructions Page ====== */}
        {currentPage === "instructions" && passcodeVerified && (
          <div className="instructions-page">
            <div className="instructions-header">
              <div style={{ marginLeft: "2%" }}>
                <h2 className="text-name" style={{ textAlign: "center", fontSize: "20px", fontWeight: "600", marginBottom: "20px" }}>
                  {testData.examName || `${subject} ${category} Flash Test`}
                </h2>

                <div className="duration-container">
                  {/* Duration Card */}
                  <div className="duration-box">
                    <span className="duration-value">
                      {testData.duration > 0 ? testData.duration : (testData.settings?.timeLimit > 0 ? testData.settings.timeLimit : 30)}
                    </span>
                    <span style={{ color: "var(--theme-current-bg)" }}>Mins</span>
                  </div>

                  {/* Questions Card */}
                  <div className="duration-box">
                    <span className="duration-value">{questions.length}</span>
                    <span style={{ color: "var(--theme-current-bg)" }}>Questions</span>
                  </div>
                </div>
              </div>
            </div>

            <br />

            <div className="instructions" style={{ paddingLeft: "2%", backgroundColor: "#F8F8F8", padding: "15px", borderRadius: "8px", textAlign: "left" }}>
              <span className="instructions-title">Instructions</span>
              <ul className="instructions-list">
                <li>You need to score at least 60% to pass the test.</li>
                <li>Once started, the test cannot be paused or reattempted in the same session.</li>
                <li>Please complete the test independently. External help is prohibited.</li>
                <li>Ensure all questions are answered before submitting.</li>
              </ul>
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", gap: "12px", marginTop: "20px" }}>
              <button
                onClick={handleStartTest}
                className="start-btn"
                disabled={startingTest}
                style={{ opacity: startingTest ? 0.7 : 1, cursor: startingTest ? "not-allowed" : "pointer" }}
              >
                {startingTest ? "Starting..." : "Start"}
              </button>
              <button onClick={handleExit} className="second-btn" style={{ textTransform: "none" }} disabled={startingTest}>Exit</button>
            </div>
          </div>
        )}

        {/* ====== Test Page ====== */}
        {currentPage === "test" && passcodeVerified && (
          <div className="test-page">
            {/* Close Button Top Right */}
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom: "15px", paddingRight: "10px", marginTop: "10px" }}>
              <button
                onClick={handleExit}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "linear-gradient(0deg, #E3E3E3 0%, #FFFFFF 100%)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  border: "none",
                  boxShadow: "0px 0px 4px rgba(0,0,0,0.1)",
                  padding: 0,
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#000" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            <h2 className="exam-title" style={{ color: "var(--theme-current-bg)", fontWeight: 600, fontSize: "25px", fontFamily: "Poppins" }}>
              {testData.examName || `${subject} Flash Test`}
            </h2>

            <div className="test-content">

              {/* Left Section */}
              <div className="test-left" style={{
                textAlign: "left",
                position: "relative",
                backgroundImage: `url(${theme.id === "bitlabs"
                  ? require("../../images/bitLabs.png")
                  : theme.id === "tekworks"
                    ? require("../../images/tekworks.png")
                    : require("../../images/symphonize.png")
                  })`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "40%",
                backgroundBlendMode: "overlay",
                backgroundColor: "rgba(255, 255, 255, 0.95)"
              }}>

                <div className="header">
                  <h4 className="test-sub" style={{ fontSize: "20px", fontWeight: "700", marginBottom: "10px" }}>
                    Question {currentQuestionIndex + 1}/{questions.length}
                  </h4>
                  <div className="progress-bar-container">
                    <div
                      className="progress-bar-fill"
                      style={{ width: `${((currentQuestionIndex + 1) / questions.length) * 100}%` }}
                    />
                  </div>
                </div>

                {/* Question & Options Area */}
                <div className="question no-select" style={{ marginTop: "25px" }}>
                  <ul>
                    <li>
                      <p className="question1 no-select" style={{ fontSize: "16px", fontWeight: "500", color: "#1e293b", lineHeight: "1.6" }}>
                        {currentQuestionIndex + 1}.&nbsp;
                        <span dangerouslySetInnerHTML={{ __html: formatQuestionText(questions[currentQuestionIndex]?.question) }} />
                      </p>
                      {questions[currentQuestionIndex]?.code && (
                        <pre className="code-snippet-box" style={{ background: "#1e1e1e", color: "#d4d4d4", padding: "12px", borderRadius: "6px", fontFamily: "monospace", textAlign: "left", overflowX: "auto", margin: "15px 0", borderLeft: "4px solid #F68318;" }}>
                          <code>{questions[currentQuestionIndex].code}</code>
                        </pre>
                      )}
                    </li>

                    <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "12px" }}>
                      {questions[currentQuestionIndex]?.options && Object.entries(questions[currentQuestionIndex].options).map(([key, option]) => {
                        const displayKey = key.toUpperCase(); // "A", "B", "C", "D"
                        return (
                          <li key={key} style={{ listStyleType: "none" }}>
                            <label className="question-label no-select" style={{ marginLeft: "0" }}>
                              <input
                                type="radio"
                                value={displayKey}
                                checked={selectedOptions[currentQuestionIndex] === displayKey}
                                onChange={handleOptionChange}
                                className="question-radio"
                              />
                              <span
                                className="no-select"
                                style={{ color: "#334155", display: "inline-block", marginLeft: "10px" }}
                              >
                                <strong>{displayKey}.</strong> <span dangerouslySetInnerHTML={{ __html: String(option || "").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br/>").replace(/```/g, "") }} />
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </div>
                  </ul>
                </div>

                {/* Navigation Footer */}
                <div className="footer1" style={{ marginTop: "30px" }}>
                  <button
                    disabled={currentQuestionIndex === 0}
                    onClick={handleBackQuestion}
                    className="second-btn"
                  >
                    Previous
                  </button>
                  {currentQuestionIndex < questions.length - 1 ? (
                    <button onClick={handleNextQuestion} className="navigation-btn">
                      Next
                    </button>
                  ) : (
                    <button
                      onClick={() => setShowSubmitConfirm(true)}
                      className="navigation-btn"
                      style={{ background: "#1aae55" }}
                    >
                      Submit Test
                    </button>
                  )}
                </div>
              </div>

              {/* Right Section */}
              <div className="test-right">
                {/* Timer Box */}
                <div className="timer-box">
                  <h4 className="timer-title">Time duration</h4>
                  <div className="timer-digits">
                    <div>
                      <span className="time-num">
                        {String(Math.floor(remainingTime / 3600)).padStart(2, "0")}
                      </span>
                      <p style={{ margin: "0" }}>Hrs</p>
                    </div>
                    <div>
                      <span className="time-num">
                        {String(Math.floor((remainingTime % 3600) / 60)).padStart(2, "0")}
                      </span>
                      <p style={{ margin: "0" }}>Mins</p>
                    </div>
                    <div>
                      <span className="time-num">
                        {String(remainingTime % 60).padStart(2, "0")}
                      </span>
                      <p style={{ margin: "0" }}>Secs</p>
                    </div>
                  </div>
                  <div className="divider-line" />
                </div>

                {/* Grid Tracker */}
                <div className="questions-box">
                  <h4 className="questions-title">Questions</h4>
                  <div className="question-grid">
                    {questions.map((_, index) => {
                      const isCurrent = index === currentQuestionIndex;
                      const isAnswered = !!selectedOptions[index];
                      const isVisited = visitedQuestions[index];
                      const isNotAnswered = isVisited && !isAnswered && !isCurrent;

                      return (
                        <div
                          key={index}
                          onClick={() => handleQuestionClick(index)}
                          className={`question-indicator 
                          ${isCurrent ? "current" : ""}
                          ${isAnswered ? "answered" : ""}
                          ${isNotAnswered ? "not-answered" : ""}
                        `}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </div>
                      );
                    })}
                  </div>

                  <div className="question-legend" style={{ display: "flex", flexDirection: "row", gap: "6px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span className="legend-box not-attempted" />
                      <span>Not visited</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span className="legend-box answered" />
                      <span>Answered</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span className="legend-box not-answered" />
                      <span>Visited</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span className="legend-box current" />
                      <span>Current</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        )}

        {/* ====== Scorecard / Results Page ====== */}
        {currentPage === "scorecard" && passcodeVerified && (
          <div className="instructions-page" style={{ textAlign: "center" }}>
            {isViolationSubmitted && (
              <div style={{
                background: "#fef2f2",
                border: "1px solid #fee2e2",
                borderRadius: "12px",
                padding: "16px 20px",
                color: "#991b1b",
                fontSize: "14.5px",
                fontWeight: "600",
                maxWidth: "480px",
                margin: "0 auto 24px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "center"
              }}>
                <span>⚠️</span>
                <span>This exam was auto-submitted due to a tab-switching or window minimize infraction.</span>
              </div>
            )}

            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "24px",
              maxWidth: "600px",
              margin: "0 auto 40px auto",
              padding: "20px"
            }}>
              {/* Top text column */}
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "72px", marginBottom: "15px" }}>
                  {(!testData.settings || testData.settings.showScore)
                    ? (score >= (testData.settings?.passingScore ?? 60) ? "🏆" : "🙂")
                    : "✅"}
                </div>

                <h2 className="flash-test-title" style={{
                  color: (!testData.settings || testData.settings.showScore)
                    ? (score >= (testData.settings?.passingScore ?? 60) ? "#1aae55" : "var(--theme-current-bg)")
                    : "#F97316",
                  marginBottom: "12px",
                  fontSize: "36px",
                  fontWeight: "700"
                }}>
                  {(!testData.settings || testData.settings.showScore)
                    ? (score >= (testData.settings?.passingScore ?? 60) ? "Test Passed!" : "Test Completed")
                    : "Assessment Completed!"}
                </h2>

                <p className="flash-test-subtitle" style={{ fontSize: "16px", color: "#1e293b", margin: "0 auto 25px auto" }}>
                  You have successfully completed the <span style={{ textTransform: "lowercase" }}>{subject}</span> <strong>FLASH TEST</strong>
                </p>

                <div style={{ marginBottom: "15px" }}>
                  <button
                    onClick={() => navigate("/applicanthome")}
                    className="navigation-btn"
                    style={{
                      background: "linear-gradient(135deg, #F97316 0%, #EA580C 100%)",
                      color: "white",
                      border: "none",
                      padding: "12px 30px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "600",
                      boxShadow: "0 4px 10px rgba(249, 115, 22, 0.2)"
                    }}
                  >
                    Back to Dashboard
                  </button>
                </div>
              </div>

              {/* Bottom scorecard visualization card */}
              {(!testData.settings || testData.settings.showScore) && (
                <div style={{
                  width: "100%",
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: "16px",
                  padding: "25px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)"
                }}>
                  <div style={{
                    fontSize: "14px",
                    color: "#0f172a",
                    fontWeight: "800",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    marginBottom: "15px"
                  }}>
                    Your Score
                  </div>

                  {/* Radial progress representation - smaller size */}
                  <div style={{
                    position: "relative",
                    width: "140px",
                    height: "140px",
                    borderRadius: "50%",
                    background: `conic-gradient(var(--theme-current-bg) ${score * 3.6}deg, #e2e8f0 ${score * 3.6}deg)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    {/* Inner cutout hole to form the circular ring */}
                    <div style={{
                      width: "110px",
                      height: "110px",
                      borderRadius: "50%",
                      backgroundColor: "#f8fafc",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{
                        fontSize: "30px",
                        fontWeight: "800",
                        color: "var(--theme-current-bg)"
                      }}>
                        {score}%
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Show correct answers review if enabled */}
            {testData.settings?.showAnswers && (() => {
              // Pre-calculate correct, incorrect, not attempted stats
              let correctCount = 0;
              let incorrectCount = 0;
              let notAttemptedCount = 0;

              questions.forEach((q, idx) => {
                const selectedKey = selectedOptions[idx] ? selectedOptions[idx].toUpperCase() : null;
                if (!selectedKey) {
                  notAttemptedCount++;
                } else if (selectedKey === q.correctOption.toUpperCase()) {
                  correctCount++;
                } else {
                  incorrectCount++;
                }
              });

              const currentActiveQ = questions[activeReviewQuestionIndex];
              const activeSelectedKey = selectedOptions[activeReviewQuestionIndex] ? selectedOptions[activeReviewQuestionIndex].toUpperCase() : null;
              const isActiveNotAttempted = !activeSelectedKey;
              const isActiveCorrect = !isActiveNotAttempted && activeSelectedKey === currentActiveQ.correctOption.toUpperCase();
              const activeCorrectKey = currentActiveQ.correctOption ? currentActiveQ.correctOption.toUpperCase() : "A";
              // Pagination calculations
              const itemsPerPage = 20;
              const totalPages = Math.ceil(questions.length / itemsPerPage);
              const startIndex = reviewPageIndex * itemsPerPage;
              const endIndex = Math.min(startIndex + itemsPerPage, questions.length);
              const paginatedQuestions = questions.slice(startIndex, endIndex);

              return (
                <div style={{ textAlign: "left", marginTop: "40px", borderTop: "1px solid #e2e8f0", paddingTop: "30px", width: "100%", maxWidth: "800px", margin: "40px auto 0 auto" }}>

                  {/* Header row with legend and title */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <h3 style={{ fontSize: "20px", fontWeight: "700", margin: 0, color: "#0f172a", fontFamily: "Plus Jakarta Sans" }}>Review questions</h3>
                        {/* Pagination Controls */}
                        {totalPages > 1 && (
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <button
                              onClick={() => setReviewPageIndex(prev => Math.max(0, prev - 1))}
                              disabled={reviewPageIndex === 0}
                              style={{
                                border: "1px solid #cbd5e1",
                                background: reviewPageIndex === 0 ? "#f1f5f9" : "#ffffff",
                                color: reviewPageIndex === 0 ? "#94a3b8" : "#1e293b",
                                borderRadius: "4px",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: reviewPageIndex === 0 ? "not-allowed" : "pointer",
                                fontSize: "14px",
                                fontWeight: "bold"
                              }}
                            >
                              &lt;
                            </button>
                            <span style={{ fontSize: "12.5px", fontWeight: "600", color: "#64748b", fontFamily: "Plus Jakarta Sans" }}>
                              {startIndex + 1}-{endIndex} of {questions.length}
                            </span>
                            <button
                              onClick={() => setReviewPageIndex(prev => Math.min(totalPages - 1, prev + 1))}
                              disabled={reviewPageIndex === totalPages - 1}
                              style={{
                                border: "1px solid #cbd5e1",
                                background: reviewPageIndex === totalPages - 1 ? "#f1f5f9" : "#ffffff",
                                color: reviewPageIndex === totalPages - 1 ? "#94a3b8" : "#1e293b",
                                borderRadius: "4px",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: reviewPageIndex === totalPages - 1 ? "not-allowed" : "pointer",
                                fontSize: "14px",
                                fontWeight: "bold"
                              }}
                            >
                              &gt;
                            </button>
                          </div>
                        )}
                      </div>
                      <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b", fontFamily: "Plus Jakarta Sans" }}>Click the numbers to view the result</p>
                    </div>

                    {/* Summary Legends */}
                    <div style={{ display: "flex", gap: "16px", fontSize: "14px", fontWeight: "600", fontFamily: "Plus Jakarta Sans" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ width: "16px", height: "16px", borderRadius: "3px", backgroundColor: "#10b981", display: "inline-block" }}></span>
                        <span>Correct - {correctCount}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ width: "16px", height: "16px", borderRadius: "3px", backgroundColor: "#ef4444", display: "inline-block" }}></span>
                        <span>Incorrect - {incorrectCount}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ width: "16px", height: "16px", borderRadius: "3px", backgroundColor: "#cbd5e1", display: "inline-block" }}></span>
                        <span>Not attempted - {notAttemptedCount}</span>
                      </div>
                    </div>
                  </div>

                  {/* Grid Tracker - 10 per row, only showing active page's 20 items */}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(10, 1fr)",
                    gap: "10px",
                    marginBottom: "25px",
                    padding: "10px 0"
                  }}>
                    {paginatedQuestions.map((q, localIdx) => {
                      const idx = startIndex + localIdx;
                      const selectedKey = selectedOptions[idx] ? selectedOptions[idx].toUpperCase() : null;
                      const isNotAttempted = !selectedKey;
                      const isCorrect = !isNotAttempted && selectedKey === q.correctOption.toUpperCase();
                      const isActive = idx === activeReviewQuestionIndex;

                      // Border color & BG matching incorrect (light red), correct (light green), or not-attempted (light grey/white)
                      let border = "1px solid #cbd5e1";
                      let bg = "#ffffff";
                      let color = "#1e293b";

                      if (isNotAttempted) {
                        border = "1px solid #cbd5e1";
                        bg = "#f8fafc";
                        color = "#64748b";
                      } else if (isCorrect) {
                        border = "2px solid #10b981";
                        bg = "#ecfdf5";
                        color = "#10b981";
                      } else {
                        border = "2px solid #ef4444";
                        bg = "#fef2f2";
                        color = "#ef4444";
                      }

                      return (
                        <div
                          key={idx}
                          onClick={() => setActiveReviewQuestionIndex(idx)}
                          style={{
                            height: "40px",
                            borderRadius: "6px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "700",
                            fontSize: "14px",
                            cursor: "pointer",
                            border: isActive ? "3px solid #3b82f6" : border,
                            background: bg,
                            color: color,
                            boxShadow: isActive ? "0 0 0 3px rgba(59, 130, 246, 0.2)" : "none",
                            fontFamily: "Plus Jakarta Sans",
                            transition: "all 0.15s ease-in-out"
                          }}
                        >
                          {String(idx + 1).padStart(2, "0")}
                        </div>
                      );
                    })}
                  </div>

                  {/* Single Active Question Card Preview */}
                  {currentActiveQ && (
                    <div style={{
                      padding: "25px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
                      position: "relative",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      MozUserSelect: "none",
                      msUserSelect: "none"
                    }}
                      onCopy={(e) => {
                        e.preventDefault();
                        alert("Copying questions is disabled.");
                      }}>

                      {/* Badge Indicator in top right */}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                        <span style={{ fontSize: "14px", fontWeight: "700", color: "#1e293b", fontFamily: "Plus Jakarta Sans" }}>
                          Question {activeReviewQuestionIndex + 1}
                        </span>
                        {(() => {
                          if (isActiveNotAttempted) {
                            return (
                              <span style={{
                                fontSize: "12px", padding: "6px 14px", borderRadius: "6px",
                                fontWeight: "700", background: "rgba(100,116,139,0.1)", color: "#64748b",
                                fontFamily: "Plus Jakarta Sans"
                              }}>
                                Not Attempted
                              </span>
                            );
                          }
                          return (
                            <span style={{
                              fontSize: "12px", padding: "6px 14px", borderRadius: "6px",
                              fontWeight: "700",
                              background: isActiveCorrect ? "#ecfdf5" : "#fef2f2",
                              color: isActiveCorrect ? "#10b981" : "#ef4444",
                              border: isActiveCorrect ? "1px solid #10b981" : "1px solid #ef4444",
                              fontFamily: "Plus Jakarta Sans"
                            }}>
                              {isActiveCorrect ? "Correct" : "Incorrect"}
                            </span>
                          );
                        })()}
                      </div>

                      {/* Question Text */}
                      <h4 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "20px", color: "#0f172a", textAlign: "left", lineHeight: "1.6", fontFamily: "Plus Jakarta Sans" }}>
                        <span dangerouslySetInnerHTML={{ __html: formatQuestionText(currentActiveQ.question) }} />
                      </h4>

                      {currentActiveQ.code && (
                        <pre className="code-snippet-box" style={{ background: "#1e1e1e", color: "#d4d4d4", padding: "12px", borderRadius: "6px", fontFamily: "monospace", textAlign: "left", overflowX: "auto", margin: "15px 0", borderLeft: `4px solid ${theme.primary}` }}>
                          <code>{currentActiveQ.code}</code>
                        </pre>
                      )}

                      {/* Options List */}
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px", fontSize: "14px", marginTop: "12px" }}>
                        {(() => {
                          let optionsEntries = [];
                          if (currentActiveQ.options && typeof currentActiveQ.options === "object" && !Array.isArray(currentActiveQ.options)) {
                            optionsEntries = Object.entries(currentActiveQ.options).map(([key, val]) => [key.toUpperCase(), val]);
                          } else if (Array.isArray(currentActiveQ.options)) {
                            const keys = ["A", "B", "C", "D"];
                            optionsEntries = currentActiveQ.options.map((val, idx) => [keys[idx] || "", val]);
                          }

                          return optionsEntries.map(([optionKey, optionText]) => {
                            const isSelected = activeSelectedKey === optionKey;
                            const isCorrectOption = activeCorrectKey === optionKey;

                            let optionStyle = {
                              padding: "14px 18px",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e1",
                              background: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              fontSize: "14px",
                              color: "#334155",
                              lineHeight: "1.5",
                              textAlign: "left",
                              fontFamily: "Plus Jakarta Sans"
                            };

                            let icon = null;
                            let statusText = null;

                            if (activeSelectedKey) {
                              if (isSelected && isCorrectOption) {
                                optionStyle.border = "2px solid #10b981";
                                optionStyle.background = "#ecfdf5";
                                optionStyle.color = "#065f46";
                                optionStyle.fontWeight = "600";
                                icon = <span style={{ color: "#10b981", fontWeight: "bold" }}>✓</span>;
                                statusText = (
                                  <span style={{
                                    marginLeft: "auto", color: "#10b981", fontSize: "11px", fontWeight: "700", flexShrink: 0
                                  }}>
                                    Candidate's Selection & Correct Answer
                                  </span>
                                );
                              } else if (isSelected && !isCorrectOption) {
                                optionStyle.border = "2px solid #ef4444";
                                optionStyle.background = "#fef2f2";
                                optionStyle.color = "#991b1b";
                                optionStyle.fontWeight = "600";
                                icon = <span style={{ color: "#ef4444", fontWeight: "bold" }}>✗</span>;
                                statusText = (
                                  <span style={{
                                    marginLeft: "auto", color: "#ef4444", fontSize: "11px", fontWeight: "700", flexShrink: 0
                                  }}>
                                    Candidate's Selection
                                  </span>
                                );
                              } else if (!isSelected && isCorrectOption) {
                                optionStyle.border = "2px solid #10b981";
                                optionStyle.background = "#ecfdf5";
                                optionStyle.color = "#065f46";
                                optionStyle.fontWeight = "600";
                                icon = <span style={{ color: "#10b981", fontWeight: "bold" }}>✓</span>;
                                statusText = (
                                  <span style={{
                                    marginLeft: "auto", color: "#10b981", fontSize: "11px", fontWeight: "700", flexShrink: 0
                                  }}>
                                    Correct Answer
                                  </span>
                                );
                              }
                            } else if (isCorrectOption) {
                              optionStyle.border = "2px solid #10b981";
                              optionStyle.background = "#ecfdf5";
                              optionStyle.color = "#065f46";
                              optionStyle.fontWeight = "600";
                              icon = <span style={{ color: "#10b981", fontWeight: "bold" }}>✓</span>;
                              statusText = (
                                <span style={{
                                  marginLeft: "auto", color: "#10b981", fontSize: "11px", fontWeight: "700", flexShrink: 0
                                }}>
                                  Correct Answer
                                </span>
                              );
                            }

                            return (
                              <div key={optionKey} style={optionStyle}>
                                {icon}
                                <span><strong>{optionKey}.</strong> <span dangerouslySetInnerHTML={{ __html: String(optionText || "").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br/>").replace(/```/g, "") }} /></span>
                                {statusText}
                              </div>
                            );
                          });
                        })()}
                      </div>

                      {/* Explanation block */}
                      {/* {currentActiveQ.answerText && (
                      <div style={{
                        marginTop: "20px",
                        background: "#fffbeb",
                        border: "1px solid #fef3c7",
                        borderRadius: "8px",
                        padding: "14px 18px",
                        fontSize: "14px",
                        color: "#78350f",
                        textAlign: "left",
                        fontFamily: "Plus Jakarta Sans"
                      }}>
                        <strong>Explanation:</strong> <span dangerouslySetInnerHTML={{ __html: formatQuestionText(currentActiveQ.answerText) }} />
                      </div>
                    )} */}

                    </div>
                  )}

                </div>
              );
            })()}


          </div>
        )}

        {/* Fullscreen Exit Prompt Modal */}
        {showFullscreenExitModal && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(15, 23, 42, 0.75)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px"
          }}>
            <div style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              width: "100%",
              maxWidth: "500px",
              padding: "40px 32px",
              textAlign: "center",
              border: "1px solid #e2e8f0",
              position: "relative"
            }}>
              {/* Close Button x */}
              <button
                onClick={handleReturnToFullscreen}
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "#f1f5f9",
                  border: "none",
                  color: "#64748b",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.2s, color 0.2s"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#e2e8f0";
                  e.currentTarget.style.color = "#334155";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#f1f5f9";
                  e.currentTarget.style.color = "#64748b";
                }}
              >
                ×
              </button>

              {/* Alarm Siren Icon */}
              <div style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "20px"
              }}>
                <img
                  src={sirenImg}
                  alt="Warning Icon"
                  style={{ width: "80px", height: "auto" }}
                />
              </div>

              <h3 style={{
                fontSize: "22px",
                fontWeight: "700",
                color: "#ff4d4f",
                margin: "0 0 16px"
              }}>
                Warning: Fullscreen exited
              </h3>

              <p style={{
                fontSize: "14.5px",
                color: "#475569",
                lineHeight: "1.6",
                margin: "0 0 28px",
                textAlign: "center"
              }}>
                Existing fullscreen mode is not allowed during the test.<br />
                Do you want to submit your exam now, or continue the test in fullscreen?
              </p>

              <div style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px"
              }}>
                <button
                  onClick={handleReturnToFullscreen}
                  style={{
                    background: "transparent",
                    color: "var(--theme-primary, #F68318)",
                    border: "1.5px solid var(--theme-primary, #F68318)",
                    borderRadius: "8px",
                    padding: "10px 24px",
                    fontSize: "14.5px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "135px",
                    transition: "background 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = `${theme.primary}10`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  Continue
                </button>

                <button
                  onClick={handleConfirmSubmitFromModal}
                  style={{
                    background: "var(--theme-primary, #F68318)",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 24px",
                    fontSize: "14.5px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "135px",
                    transition: "background 0.2s"
                  }}
                  // onMouseEnter={(e) => {
                  //   // e.currentTarget.style.background = "var(--theme-secondary, #e66a0e)";
                  // }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "var(--theme-primary, #F68318)";
                  }}
                >
                  Submit Exam
                </button>
              </div>
            </div>
          </div>
        )}
        {isSubmittingTest && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(15, 23, 42, 0.75)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px"
          }}>
            <div style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              width: "100%",
              maxWidth: "360px",
              padding: "40px 32px",
              textAlign: "center",
              border: "1px solid #e2e8f0"
            }}>
              {/* Spinning/Loading Icon */}
              <div style={{
                width: "64px",
                height: "64px",
                border: "5px solid #f3f3f3",
                borderTop: `5px solid var(--theme-current-bg)`,
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto 24px"
              }}></div>

              <h3 style={{
                fontSize: "18px",
                fontWeight: "700",
                color: "#0f172a",
                margin: "0 0 8px"
              }}>
                Submitting Your Exam
              </h3>

              <p style={{
                fontSize: "14.5px",
                color: "#64748b",
                lineHeight: "1.5",
                margin: 0
              }}>
                Please wait while we record your responses and generate your score. Do not close or refresh this page.
              </p>
            </div>
          </div>
        )}
      </div>
      <TestFooter />
    </>
  );
};

export default ApplicantFlashTest;
